import React from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-cocoa px-5 pb-12 pt-2 text-cream" data-id="element-89" data-mp="2082jj8gp4kfn">
      <div className="mx-auto max-w-4xl border-t border-cream/15 pt-10 text-center" data-id="element-90" data-mp="209x58ozskgks">
        <p className="font-display text-2xl" data-id="element-91" data-mp="2f2qydd7zkv7x">Megapack Bolsos Crochet Pro</p>
        <p className="mt-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-92" data-mp="2a71u4wl0uq5a">De hilo a bolso</p>

        <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-cream/75" data-id="element-93" data-mp="1mgfmv7iud9wc">
          <a href="#soporte" className="inline-flex items-center gap-1.5 transition-colors duration-150 hover:text-gold" data-id="element-94" data-mp="1hf8htg832otd">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="1repjlmk7sik2" /> Soporte
          </a>
          <a href="#contacto" className="inline-flex items-center gap-1.5 transition-colors duration-150 hover:text-gold" data-id="element-96" data-mp="13peqmr93vsgh">
            <MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="yrd7657rpr4h" /> Contacto
          </a>
          <a href="#terminos" className="transition-colors duration-150 hover:text-gold" data-id="element-98" data-mp="1eiviwhjnov1k">
            Términos y condiciones
          </a>
        </nav>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-cream/60" data-id="element-99" data-mp="1ihkxgdgfkims">
          Producto 100% digital. No incluye materiales físicos. Los resultados dependen de la práctica de cada persona.
          © {new Date().getFullYear()} Megapack Bolsos Crochet Pro.
        </p>
      </div>
    </footer>;
}